import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useAuth, useUserSettings } from '../../../../core';
import { JobFieldHeadingWithTooltip } from './JobFieldHeadingWithTooltip';

const styles = {
    userText: {
        textTransform: 'capitalize',
        pl: '12px',
        pt: 1,
    },
    popperStyles: {
        width: '232px',
        height: '62px',
    },
};

const JobExecutor = (): React.JSX.Element => {
    const { getUserName } = useAuth();
    const { getElevatedSystemWallet } = useUserSettings();

    const getExecutorName = (): string => {
        const elevatedUser: string | undefined =
            getElevatedSystemWallet()?.description;
        const elevated: boolean = getElevatedSystemWallet()?.elevated ?? false;

        return (elevated && elevatedUser) || getUserName();
    };

    return (
        <Grid>
            <JobFieldHeadingWithTooltip
                label='Executing As'
                title={
                    'GraphChain operations can be executed as a custodian or tenant system wallet'
                }
                popperStyles={styles.popperStyles}
            />
            <Typography sx={styles.userText}>{getExecutorName()}</Typography>
        </Grid>
    );
};

export default JobExecutor;
